/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Divider, Form, Image, Input, Row, Spin, Tag } from 'antd';
import { Content } from 'antd/es/layout/layout';
import CartApi from 'apis/CartApi';
import ProductApi from 'apis/ProductApi';
import { defaultImage } from 'assets/images';
import { Copy, Group123423 } from 'assets/svg';
import { STATUS } from 'constants/reponseStatus';
import { get } from 'lodash';
import React, {
  Key,
  forwardRef,
  useEffect,
  useState,
  useImperativeHandle,
} from 'react';
import { useQuery } from 'react-query';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import handleError401 from 'utils/handleError401';

interface IProps {
  data: any;
  setMin: (data?: any) => void;
  setMax: (data?: any) => void;
}

const ProductInfo = forwardRef((props: IProps, ref: any): JSX.Element => {
  const { data, setMin, setMax } = props;
  const initMin = data?.order_min;
  const initMax = data?.order_max;
  const [mainPic, setMainPic] = useState<any>(0);
  const [dataProduct, setDataProduct] = useState<any>(data);

  const [images, setImages] = useState<any[]>([{ image_path: defaultImage }]);
  const [listImages, setListImages] = useState<any[]>([]);
  const [product, setProduct] = useState<any>();

  const { isLoading: isLoading, refetch } = useQuery(
    ['getyDetail'],
    () => CartApi.getProductTvvDetail(dataProduct?.cart_register_detail_id),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setProduct(response.data);
          setListImages(response.data?.list_image || []);
          if (response.data.image_default) {
            setImages([{ image_path: response.data.image_default }]);
          } else {
            setImages([{ image_path: defaultImage }]);
          }
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  useEffect(() => {
    if (dataProduct) {
      refetch();
    }
  }, [dataProduct]);

  const setData = (data: any) => {
    setDataProduct(data);
  };

  useImperativeHandle(ref, () => ({
    setData,
  }));

  const getDataNi = Array.from(
    new Set((product?.other_info || []).map((obj: any) => obj.ni))
  );

  return (
    <Spin size="small" spinning={isLoading}>
      <Content>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          // onFinish={onFinish}
          autoComplete="off"
        >
          <Row style={{ justifyContent: 'start' }}>
            <Col className="flex" style={{ width: '50%' }}>
              <div
                className="flex flex-col"
                style={{
                  gap: '4px',
                  overflowY: 'scroll',
                  maxHeight: '500px',
                  width: '15%',
                }}
              >
                {/* {images.map((image, index) => (
                  <Image
                    key={index}
                    className="product-image-item bg-neutral-95 border border-solid rounded-lg active"
                    width={'100%'}
                    // height={'40px'}
                    preview={false}
                    src={image.image_path ? image.image_path : ''}
                    onClick={() => {
                      setMainPic(index);
                    }}
                  />
                ))} */}
                {listImages.map((image, index) => (
                  <Image
                    key={index}
                    className="product-image-item bg-neutral-95 rounded-lg active"
                    width={'100%'}
                    // height={'40px'}
                    preview={false}
                    src={image ? image : ''}
                    onClick={() => {
                      setMainPic(index);
                    }}
                  />
                ))}
              </div>

              <Col
                style={{
                  paddingLeft: '8px',
                  paddingRight: '8px',
                  width: '70%',
                }}
              >
                <Image.PreviewGroup
                  items={listImages?.map((image) => image ?? defaultImage)}
                  // preview={{ current: mainPic }}
                >
                  {listImages && (
                    <Image
                      className="rounded-lg"
                      src={
                        listImages[mainPic] ? listImages[mainPic] : defaultImage
                      }
                    />
                  )}
                  {/* {images && (
                    <Image
                      className="rounded-lg"
                      src={
                        images[mainPic]?.image_path
                          ? images[mainPic]?.image_path
                          : ''
                      }
                    />
                  )} */}
                </Image.PreviewGroup>
              </Col>
            </Col>
            <Col span={12}>
              <Col span={24} className="text-xl">
                {product?.ma_mau || '-'}
              </Col>
              <Col
                span={24}
                className="text-primary-50 text-2xl font-bold mt-2"
              >
                {product?.ten_mau}
              </Col>
              <Col
                span={24}
                className="mt-2 text-2xl"
                style={{ color: '#C9A46D', fontWeight: 'bold' }}
              >
                {formatCurrencyVND(product?.cost_price || '0')}
              </Col>
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              {data.order_min && data.order_max && (
                <Col
                  span={24}
                  style={{ display: 'flex', alignItems: 'center' }}
                  className="mt-2 text-base"
                >
                  <Group123423 />
                  Đã đăng ký
                </Col>
              )}

              <Col span={24} className="mt-2">
                <Row className="custom-col-tag">
                  <Col span={3}> Số ni</Col>
                  {(getDataNi || []).map((item: any, index: any) => (
                    <Col key={index} span={3}>
                      <Tag color="#EAF2FF">{item}</Tag>
                    </Col>
                  ))}
                </Row>
              </Col>
              {/* <Col className="mt-2">
                  <Row justify="start" align="middle">
                    <Col span={3}> Đăng ký</Col>
                    <Col className="w-1/12" />
                    <Col className="w-1/4">
                      <Row justify="space-between" align="middle">
                        <Col className="w-full text-center">Min</Col>
                        <Col>
                          <Input
                            onChange={(event) => setMin(event)}
                            value={initMin}
                            defaultValue={data?.old_order_min}
                            style={{
                              height: '28px',
                              width: '100%',
                              borderRadius: '5px',
                              textAlign: 'center',
                            }}
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="w-1/12" />
                    <Col className="w-1/4">
                      <Row justify="space-between" align="middle">
                        <Col className="w-full text-center">Max</Col>
                        <Col>
                          <Input
                            onChange={(event) => setMax(event)}
                            value={initMax}
                            defaultValue={data?.old_order_max}
                            style={{
                              height: '28px',
                              width: '100%',
                              borderRadius: '5px',
                              textAlign: 'center',
                            }}
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  span={24}
                  style={{ display: 'flex', alignItems: 'center' }}
                  className="mt-2"
                >
                  <Copy />
                  Sao chép đăng ký cũ
                </Col> */}
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
              <Col
                span={24}
                style={{ display: 'flex', alignItems: 'center' }}
                className="mt-2"
              >
                Vốn tạm tính: &nbsp;&nbsp;&nbsp;{' '}
                <span
                  style={{
                    color: '#C9A46D',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    verticalAlign: 'middle',
                  }}
                >
                  {data?.order_min
                    ? formatCurrencyVND(product?.cost_price * data.order_min)
                    : '0đ'}
                  {' - '}
                  {data?.order_max
                    ? formatCurrencyVND(product?.cost_price * data.order_max)
                    : '0đ'}
                </span>
              </Col>
            </Col>
          </Row>
          <Row
            className="mt-6 custom-title"
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          >
            <Col span={4}>
              <Row>
                <Col span={24}>
                  <strong>Aging Danh mục</strong>
                </Col>
                <Col span={24}>{product?.aging || '-'}</Col>
                <Col span={24}>
                  <strong>Aging cửa hàng</strong>
                </Col>
                <Col span={24}>{product?.aging_shop || '-'}</Col>
                <Col span={24}>
                  <strong>Màu sắc</strong>
                </Col>
                <Col span={24}>{product?.mausac_text || '-'}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong>Mã code</strong>
                </Col>
                <Col span={24}>{product?.pro_code || '-'}</Col>
                <Col span={24}>
                  <strong>Basic</strong>
                </Col>
                <Col span={24}>{product?.basic_product || '-'}</Col>
                <Col span={24}>
                  <strong>Ngành hàng</strong>
                </Col>
                <Col span={24}>{product?.prod_grp2_name || '-'}</Col>
                <Col span={24}>
                  <strong>Dòng hàng SAP</strong>
                </Col>
                <Col span={24}>{product?.line_sap_text || '-'}</Col>
                <Col span={24}>
                  <strong>Xman</strong>
                </Col>
                <Col span={24}>{product?.line_xman_text || '-'}</Col>
                <Col span={24}>
                  <strong>Giá bán</strong>
                </Col>
                <Col span={24}>{formatCurrencyVND(product?.price) || '-'}</Col>
                <Col span={24}>
                  <strong>Giá vốn tồn tham khảo</strong>
                </Col>
                <Col span={24}>{formatCurrencyVND(product?.cost_price)}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong>Phân khúc giá</strong>
                </Col>
                <Col span={24}>{product?.phankhuc_gia || '-'}</Col>
                <Col span={24}>
                  <strong>BST</strong>
                </Col>
                <Col span={24}>{product?.bst_text || '-'}</Col>
                <Col span={24}>
                  <strong>Bộ</strong>
                </Col>
                <Col span={24}>{product?.zma_bo_text || '-'}</Col>
                <Col span={24}>
                  <strong>Cặp</strong>
                </Col>
                <Col span={24}>{product?.zma_ts_cap_text || '-'}</Col>
                <Col span={24}>
                  <strong>Mã code</strong>
                </Col>
                <Col span={24}>{product?.pro_code || '-'}</Col>
                <Col span={24}>
                  <strong>Nhóm đá</strong>
                </Col>
                <Col span={24}>{product?.nhom_da || '-'}</Col>
                <Col span={24}>
                  <strong>Loại đá phụ</strong>
                </Col>
                <Col span={24}>{product?.daphu || '-'}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Col span={24}>
                <strong>Chủng loại</strong>
              </Col>
              <Col span={24}>{product?.chungloai_text || '-'}</Col>
              <Col span={24}>
                <strong>Giới tính</strong>
              </Col>
              <Col span={24}>{product?.gioitinh_text || '-'}</Col>
              <Col span={24}>
                <strong>PL Style</strong>
              </Col>
              <Col span={24}>-</Col>
              <Col span={24}>
                <strong>Size ổ hột</strong>
              </Col>
              <Col span={24}>{product?.ohot_kc_text || '-'}</Col>
              <Col span={24}>
                <strong>Material Type</strong>
              </Col>
              <Col span={24}>{product?.material_type || '-'}</Col>
              <Col span={24}>
                <strong>Tuổi vàng</strong>
              </Col>
              <Col span={24}>{product?.purity_of_gold || '-'}</Col>
              <Col span={24}>
                <strong>PLHH</strong>
              </Col>
              <Col span={24}>{product?.plhh || '-'}</Col>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong>Phân nhóm</strong>
                </Col>
                <Col span={24}>{product?.phan_nhom || '-'}</Col>
                <Col span={24}>
                  <strong>Is_DMHHKN</strong>
                </Col>
                <Col span={24}>{product?.is_dmhhkn || '-'}</Col>
                <Col span={24}>
                  <strong>Material (Mẫu đại diện)</strong>
                </Col>
                <Col span={24}>
                  {product?.mau_dai_dien === true ? 'Có' : 'Không'}
                </Col>
                <Col span={24}>
                  <strong>Material Group</strong>
                </Col>
                <Col span={24}>{product?.material_group || '-'}</Col>
                <Col span={24}>
                  <strong>PL ni</strong>
                </Col>
                <Col span={24}>{product?.item_size || '-'}</Col>
                {/* <Col span={24}>
                  <strong>Đánh giá TQ</strong>
                </Col>
                <Col span={24}>{product?.kldg_3tc || '-'}</Col> */}
                <Col span={24}>
                  <strong>PL Tình trạng</strong>
                </Col>
                <Col span={24}>{product?.cnsx_text || '-'}</Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <Row
            className="mt-6 custom-title"
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          >
            <Col span={4}>
              <Row>
                <Col span={24}>
                  <strong>Đánh giá theo KV</strong>
                </Col>
                <Col span={24}>{product?.dghh_kv || '-'}</Col>
                {/* <Col span={24}>
                  <strong>Đánh giá HH theo KV</strong>
                </Col>
                <Col span={24}>{product?.dghh_kv || '-'}</Col> */}
                <Col span={24}>
                  <strong>Đánh giá TQ</strong>
                </Col>
                <Col span={24}>{product?.kldg_3tc || '-'}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong> Số tháng không phát sinh doanh thu liên tiếp</strong>
                </Col>
                <Col span={24}>
                  {product?.so_thang_khong_phat_sinh_doanh_thu_lien_tiep || '-'}
                </Col>
                <Col span={24}>
                  <strong>Doanh thu 6 tháng (VND)</strong>
                </Col>
                <Col span={24}>
                  {formatCurrencyVND(product?.doanh_thu_6_thang_vnd) || '-'}
                </Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong>Doanh số TB 6 tháng (VND)</strong>
                </Col>
                <Col span={24}>
                  {formatCurrencyVND(product?.doanh_thu_tb_6_thang_vnd) || '-'}
                </Col>
                <Col span={24}>
                  <strong>Doanh số TB 6 tháng (Món)</strong>
                </Col>
                <Col span={24}>{product?.doanh_so_tb_6_thang_mon || '-'}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong> Doanh thu kỳ vọng KV</strong>
                </Col>
                <Col span={24}>
                  {formatCurrencyVND(product?.doanh_thu_ky_vong_kv_vnd) || '-'}
                </Col>
                <Col span={24}>
                  <strong> Doanh số kỳ vọng KV</strong>
                </Col>
                <Col span={24}>{product?.doanh_so_ky_vong_kv_mon || '-'}</Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col span={24}>
                  <strong> Doanh thu kỳ vọng TQ</strong>
                </Col>
                <Col span={24}>
                  {formatCurrencyVND(product?.doanh_thu_ky_vong_tq_vnd) || '-'}
                </Col>
                <Col span={24}>
                  <strong> Doanh số kỳ vọng TQ</strong>
                </Col>
                <Col span={24}>{product?.doanh_so_ky_vong_tq_mon || '-'}</Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Content>
    </Spin>
  );
});

export default ProductInfo;
